import { render } from "@wordpress/element";
import { Block } from "./block";
import { cookies } from "../cookies";
import { COOKIE_ID } from "../constant";

const cookie = cookies.get(COOKIE_ID);

window.addEventListener("DOMContentLoaded", () => {
	const element = document.querySelector(".wp-block-steam-blocks-favorites");

	if (element) {
		const attributes = { ...element.dataset, cookie };

		render(
			<Block {...attributes} />,

			element,
		);
	}
});
